<template>
<div class="menu" v-if="Pages">
<table>
<tr><td>
<a href="https://agros.tj"><div>
    <div>
    <svg width="30" height="30" viewBox="0 0 24 24">
    <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3L2 12h3v8z"/></svg>
    </div>
  <label>Agros.tj</label></div></a>
</td><td>
<router-link to="/favorites"><div>
  <div>
     <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--jam" width="30" height="30" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
     <path d="M11.293 5.55l.707.708l.707-.707a5 5 0 1 1 7.071 7.071l-7.07 7.071a1 1 0 0 1-1.415 0l-7.071-7.071a5 5 0 1 1 7.07-7.071z" fill="currentColor"></path></svg>
  </div>
  <label>Избранное</label></div></router-link>
</td><td>
<router-link to="/podat" class="podat_footer"><div>
  <div>
    <svg width="31" height="31" viewBox="0 0 24 24">
      <path fill="currentColor" d="M11 17h2v-4h4v-2h-4V7h-2v4H7v2h4Zm1 5q-2.075 0-3.9-.788q-1.825-.787-3.175-2.137q-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175q1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138q1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175q-1.35 1.35-3.175 2.137Q14.075 22 12 22Z"/></svg>
  </div>
  <label>Разместить</label></div></router-link>
</td><td >
<router-link to="/message"><div>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--ion" width="26" height="26" preserveAspectRatio="xMidYMid meet" viewBox="0 0 512 512">
     <path d="M144 464a16 16 0 0 1-16-16v-64h-24a72.08 72.08 0 0 1-72-72V120a72.08 72.08 0 0 1 72-72h304a72.08 72.08 0 0 1 72 72v192a72.08 72.08 0 0 1-72 72H245.74l-91.49 76.29A16.05 16.05 0 0 1 144 464z" fill="currentColor"></path></svg>
</div><label>Сообщения</label></div><div v-if="getunread>0" class="i_unread">{{getunread}}</div></router-link>
</td><td>
<router-link to="/cbn"><div>
  <div>
    <svg width="28" height="28" viewBox="0 0 36 36"><path fill="currentColor" d="M30.61 24.52a17.16 17.16 0 0 0-25.22 0a1.51 1.51 0 0 0-.39 1v6A1.5 1.5 0 0 0 6.5 33h23a1.5 1.5 0 0 0 1.5-1.5v-6a1.51 1.51 0 0 0-.39-.98Z" class="clr-i-solid clr-i-solid-path-1"/><circle cx="18" cy="10" r="7" fill="currentColor" class="clr-i-solid clr-i-solid-path-2"/>
    <path fill="none" d="M0 0h36v36H0z"/></svg>
  </div>
  <label>Профиль</label></div></router-link>
</td></tr></table>
</div>
</template>
<script>
import widthwindow from "../mixins/widthwindow"
export default{
  mixins: [widthwindow],
  data (){
    return {
     Pages:true,  
        
    }
  },
  methods: {
    minwidth(){
      this.Pages = true  
    },
    maxwidth(){
      this.Pages = false  
    },
},
computed:{
getunread(){
    return this.$store.getters.getunread;
   },
}
}
</script>
<style scoped>
.menu{
border-top:1px solid #cccccc;
background-color:#ffffff;
display:block-inline;
bottom:0px;
left: 0px;
position: fixed;
min-width:100%;
max-width:100%;
z-index: 1000;
}
.i_unread{
  margin-top:-45px;
  display: inline-block;
  width:13px;
  height: 13px;
  background-color: #ff6600;
  border-radius: 50%;
  padding:2px;
  font-size: 10px;
  color:#fff;
position:absolute; 
}
.menu a{
text-decoration:none;
Color:#000000;
padding:0px;
}
.menu svg{
margin-bottom: -6px;
Color: #888888;
}
.menu table{
width: 100%;
padding:0px;
}
.menu table td{
width: 20%;
text-align: center;
}
.menu label{
font-size:10px;
}
.menu a.router-link-exact-active svg, label{
  color: #000;/*#06c;*/
}
</style>